import { useQuery } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';

export function usePolicyDetails(policyId: string | undefined) {
  return useQuery({
    queryKey: ['policy-details', policyId],
    queryFn: async () => {
      if (!policyId) throw new Error('PolicyId é obrigatório');
      const response = await policiesService.getPolicyDetails(policyId);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar detalhes da apólice');
      }
      return response.data;
    },
    enabled: !!policyId,
    staleTime: 1000 * 60 * 5,
  });
}
